const BRAND_TV_DOMAIN = process.env.REACT_APP_BRAND_TV_DOMAIN as string;
const WEBINAR_PLUS_DOMAIN = process.env.REACT_APP_WEBINAR_PLUS_DOMAIN as string;

export const getFromAppConfigForCurrentLocation = () => {
	try {
		if (window.location.hostname.endsWith(BRAND_TV_DOMAIN)) {
			return JSON.parse(process.env.REACT_APP_BRAND_TV_AUTH_CONFIG as string);
		}

		if (window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN)) {
			return JSON.parse(process.env.REACT_APP_WEBINAR_PLUS_AUTH_CONFIG as string);
		}
	} catch (error) {
		console.error('Error parsing from app config', error);
	}

	return { fromApp: 'Brandlive Platform' };
};

